// extracted by mini-css-extract-plugin
export default {"hoaTable":"HoaAccruals_hoaTable__RdMwv","radioLabel":"HoaAccruals_radioLabel__y4Jhg"};